/**
 * Davet kodunun karekodu.
 *
 * İKİ GÜVENLİK KARARI:
 *
 * 1. Kod adresin FRAGMENT kısmında taşınır (#invite=…), sorgu parametresinde
 *    değil. Fragment tarayıcıdan sunucuya HİÇ gönderilmez ve Referer
 *    başlığında görünmez. Davet kodu bir yetki anahtarı olduğu için bu ayrım
 *    önemli. Okunduktan hemen sonra da temizlenir.
 *
 * 2. QR CİHAZDA üretilir. Kodu bir QR servisine göndermek, yetki anahtarını
 *    üçüncü bir tarafa vermek olurdu.
 *
 * Kütüphane yalnızca QR istendiğinde yüklenir — her açılışta değil — ve
 * cdnjs'ten SRI integrity doğrulamasıyla gelir.
 */

const LIB_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
const LIB_SRI = 'sha384-3zSEDfvllQohrq0PHL1fOXJuC/jSOO34H46t6UQfobFOmxE5BpjjaIJY5F2/bMnU';

interface QrCtor {
  new (host: HTMLElement, opts: { text: string; width: number; height: number; correctLevel: number }): unknown;
  CorrectLevel: { M: number };
}

let loading: Promise<boolean> | null = null;

function lib(): QrCtor | undefined {
  return (globalThis as unknown as { QRCode?: QrCtor }).QRCode;
}

export function loadQrLib(): Promise<boolean> {
  if (lib()) return Promise.resolve(true);
  if (loading) return loading;
  loading = new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = LIB_SRC;
    s.integrity = LIB_SRI;
    s.crossOrigin = 'anonymous';
    s.onload = () => resolve(!!lib());
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return loading;
}

/** Davet adresi. Kod fragment'te; sunucuya gitmez. */
export function inviteUrl(code: string): string {
  return location.origin + location.pathname + '#invite=' + encodeURIComponent(code);
}

/** Karekodu verilen kaba çiz. Başarısızsa false döner; çağıran metin gösterir. */
export async function drawQr(host: HTMLElement, code: string): Promise<boolean> {
  const ok = await loadQrLib();
  const QR = lib();
  if (!ok || !QR) return false;
  try {
    new QR(host, {
      text: inviteUrl(code), width: 168, height: 168,
      correctLevel: QR.CorrectLevel.M,
    });
    return true;
  } catch {
    return false;
  }
}

/**
 * QR ile gelen kodu adresten al.
 *
 * Okunduktan hemen sonra fragment TEMİZLENİR: adres çubuğunda, geçmişte ve
 * yer imlerinde yetki anahtarı kalmasın.
 */
export function takeHashInvite(): string | null {
  const m = (location.hash || '').match(/[#&]invite=([A-Za-z0-9-]+)/);
  if (!m) return null;
  try {
    history.replaceState(null, '', location.pathname + location.search);
  } catch {
    location.hash = '';
  }
  return decodeURIComponent(m[1]).toUpperCase();
}
